module.exports = __webpack_public_path__ + "Server-Unhealthy.AzureServiceFabricCluster.3903a75bbb79eb69330c416e1b7ed9b3.hashedasset.svg";